var _circle, _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#224ED1",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_343_155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 20,
    width: 31,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.587 30.5653L45.625 25.2826L60.8126 20L76.0002 62.9215L67.4159 64.9025L54.2093 50.3752L46.2853 42.4512L49.587 37.1686V30.5653Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_343_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8554 33.2056C56.8554 30.288 54.4903 27.9229 51.5728 27.9229C48.6552 27.9229 46.2901 30.288 46.2901 33.2056C46.2901 36.1231 48.6552 38.4882 51.5728 38.4882V42.4502C46.4671 42.4502 42.3281 38.3112 42.3281 33.2056C42.3281 28.0999 46.4671 23.9609 51.5728 23.9609C56.6784 23.9609 60.8174 28.0999 60.8174 33.2056C60.8174 38.3112 56.6784 42.4502 51.5728 42.4502V38.4882C54.4903 38.4882 56.8554 36.1231 56.8554 33.2056Z",
    fill: "#224ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.224 44.4375C58.6655 44.4375 63.3271 47.2077 66.3437 50.7455C69.3005 54.2133 70.7132 58.4591 70.7132 61.6061H66.7513C66.7513 59.4705 65.7202 56.1225 63.3284 53.3171C60.9962 50.5819 57.4041 48.3995 52.224 48.3995C47.0218 48.3995 43.063 50.6033 40.3819 53.4023C37.6339 56.2712 36.376 59.6002 36.376 61.6061H32.4141C32.4141 58.3294 34.2605 54.0645 37.5213 50.6603C40.8492 47.1864 45.8047 44.4375 52.224 44.4375Z",
    fill: "#224ED1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1429 33.4531C43.1429 30.6128 40.8403 28.3103 38 28.3103C35.1597 28.3103 32.8571 30.6128 32.8571 33.4531C32.8571 36.2934 35.1597 38.596 38 38.596V42.4531C33.0294 42.4531 29 38.4237 29 33.4531C29 28.4826 33.0294 24.4531 38 24.4531C42.9706 24.4531 47 28.4826 47 33.4531C47 38.4237 42.9706 42.4531 38 42.4531V38.596C40.8403 38.596 43.1429 36.2934 43.1429 33.4531Z",
    fill: "#224ED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6552 44.4531C45.0463 44.4531 49.6716 47.1961 52.6646 50.6991C55.5983 54.1329 57 58.337 57 61.4531H53.069C53.069 59.3385 52.046 56.0233 49.6728 53.2456C47.3589 50.5372 43.7949 48.3762 38.6552 48.3762C33.4936 48.3762 29.5657 50.5584 26.9056 53.3299C24.1791 56.1706 22.931 59.467 22.931 61.4531H19C19 58.2086 20.832 53.9856 24.0673 50.6149C27.3693 47.175 32.2861 44.4531 38.6552 44.4531Z",
    fill: "#224ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab);
export default __webpack_public_path__ + "static/media/collab.52d01eb12c0d4638059947563e31c703.svg";
export { ForwardRef as ReactComponent };